//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Action,
  ActionBase,
  Illustration,
  Typography,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import translations from './Help.translations'

export default {
  components: {
    Action,
    ActionBase,
    Typography,
    Illustration,
  },
  computed: {
    ...mapGetters({
      faqUrl: 'config/getFaqUrl',
    }),
    translations: () => translations,
  },
}
